import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { CompositionEditor } from "./CompositionEditor"
import styles from './styles.module.less'
import classNames from "classnames"
import { EditCompositionModal } from "./EditCompositionModal"
import { isArray } from "lodash-es"
import { Popconfirm, Space } from "antd"
import { RunState, getStatus } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

interface ManualObject {
  type: number
  val: number[]
}
interface WarpedCompositionProps {
  value?: number[] | ManualObject
  setName?: string
  className?: string
  onChange?: (val: number[]) => void
  onDelete?: () => void
}
export const WarpedComposition = (props: WarpedCompositionProps) => {
  const status = useSelector(getStatus);
  const {value: modalVal, setName, onChange, className, onDelete} = props
  const value = isArray(modalVal) ? modalVal as number[] : ((modalVal as ManualObject)?.val || [])

  const isManual = !!(modalVal as ManualObject)?.val

  const confirm = () => {
    onDelete?.()
  }

  const disabled = status === RunState.Stop

  return <div className={classNames(styles.warpContainer, className)}>
    <div className={classNames('flex-space-btw', styles.header)}>
      <div>Composition [mol/mol]</div>
      <Space>
        {!disabled && isManual && <Popconfirm
          title="Confirm"
          description="Do you want to delete the Compositions?"
          onConfirm={confirm}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined style={{color: 'red'}} />
        </Popconfirm>}
        <div style={{cursor: 'pointer'}}>
          <EditCompositionModal value={value} setName={setName} onChange={onChange} trigger={status !== RunState.Stop && <EditOutlined />}/>
        </div>
      </Space>
      
    </div>
    <div className={styles.warpBody}>
      <CompositionEditor value={value} setName={setName} readonly={true} isManual={isManual} />
    </div>
  </div>
}